export default __webpack_public_path__ + "static/media/reflex.a6fa9d15.png";